import {Route, Switch, Redirect, Navigate} from "react-router-dom"
import {publicRoutes , privateRoutes} from "./routes"
import { ID_ROUTE, LOGIN_ROUTE } from "./util/const"
import { useSelector, useDispatch } from 'react-redux'
import { decrement, increment } from './redux/reducers'




function AppRouter() {



const {auth} = useSelector((state) => state)
  const dispatch = useDispatch()


    return auth ? (
        <Switch>
            {privateRoutes.map(({path, Component}) => (
                <Route key={path} path={path} component={Component} />
            ))}
            <Redirect to={ID_ROUTE} />
        </Switch>
    ) : (
        <Switch> 
               {publicRoutes.map(({path, Component}) => (
                <Route key={path} path={path} component={Component}  />
            ))}
            <Redirect to={LOGIN_ROUTE} />
        </Switch>
    )
}

export default AppRouter;